import React from "react";

import BenAdminOpenEnrollmentSetupApp from "BenAdminOpenEnrollmentSetup/App";
import BenAdminRenewalApp from "BenAdminRenewal/App";
import BrokerOfRecordApp from "BrokerOfRecord/App";
import EmployeeApplicationApp from "EmployeeApplication/EmployeeApplicationApp";
import EmployeeDashboardApp from "EmployeeDashboard/App";
import EmployeeRenewalApplicationApp from "EmployeeRenewalApplication/App";
import EmployerDashboardApp from "EmployerDashboard/App";
import { createBrowserHistory } from "history";
import IndividualApplicationApp from "IndividualApplication/App";
import CreateAccountApp from "Intuit/CreateAccount/App";
import IntuitErrorApp from "Intuit/ErrorApp";
import LargeGroupSurvey from "LargeGroupIntent/App";
import PartnerBrokerOnboarding from "PartnerBrokerOnboarding/App";
import PayrollLeadApp from "PayrollLead/App";
import { Router, Route, Switch } from "react-router-dom";
import RegisterBenAdminApp from "RegisterBenAdmin/App";
import RenewalSuitesComparisonApp from "RenewalSuitesComparison/App";
import SwitchCompanyApp from "SwitchCompany/App";
import SwitchFlow from "SwitchFlow/App";
import ToastApp from "Toast/App";
import ToastSsoAuthorization from "Toast/SsoAuthorization";
import ToastLaunchSimplyInsured from "Toast/ToastLaunchSimplyInsured";
import UserSettingsApp from "UserSettings/App";
import { companyTokenString } from "Utils/companyToken";
import { baseUrl as basename } from "ZeroRuby/urls";

import PageViewTracker from "./PageViewTracker";
import { OptimizeActivate } from "./snippets/optimize";

import { Page, FourOhFour, GenericErrorPage } from "./index";

export const companyPrefixURLPath = `${basename}${companyTokenString()}`;
export const history = createBrowserHistory({
  basename: companyPrefixURLPath,
});

const App = () => (
  <Page>
    <Router history={history}>
      <PageViewTracker>
        <Switch>
          <Route path="/register-large-group" children={<LargeGroupSurvey />} />
          <Route path="/register-benefits-administration" children={<RegisterBenAdminApp />} />
          <Route path="/benefits-administration/open-enrollment-setup" children={<BenAdminOpenEnrollmentSetupApp />} />
          <Route path="/benefits-administration/renewal" children={<BenAdminRenewalApp />} />
          <Route path="/partner-broker-onboarding" children={<PartnerBrokerOnboarding />} />
          <Route path="/register" children={<BrokerOfRecordApp />} />
          <Route
            path={["/employee-application", "/company-admin/employee-application/:employee_hash_id"]}
            children={({ match }) => <EmployeeApplicationApp match={match} />}
          />

          <Route
            path={["/employee-dashboard", "/company-admin/employee-dashboard/:employee_form_id"]}
            children={({ match }) => <EmployeeDashboardApp match={match} />}
          />

          <Route path="/employer-dashboard" children={({ match }) => <EmployerDashboardApp match={match} />} />
          <Route path="/renewal-suites-comparison" children={<RenewalSuitesComparisonApp />} />
          <Route
            path={["/employee-renewal", "/company-admin/employee-renewal/:employee_hash_id"]}
            children={({ match }) => <EmployeeRenewalApplicationApp match={match} />}
          />

          <Route path="/payroll-prospect" children={<PayrollLeadApp />} />
          <Route path="/:partner_type/router/payroll-prospect" children={<PayrollLeadApp />} />

          <Route path="/account/:accountId" children={<UserSettingsApp />} />
          <Route path="/switch-company" children={<SwitchCompanyApp />} />
          <Route path="/switch-flow" children={<SwitchFlow />} />
          <Route path="/toast/router/select-toast-company" children={<ToastApp />} />
          <Route path="/select-toast-company" children={<ToastApp />} />
          <Route path="/toast_connect_benefits" children={<ToastSsoAuthorization />} />
          <Route path="/toast_launch_simplyinsured" children={<ToastLaunchSimplyInsured />} />
          {/* TODO: move the CreateAccountApp into its own app. */}
          <Route path="/:companyIdToken/create-account/:account?" children={({ match }) => <CreateAccountApp match={match} />} />

          <Route path="/intuit/error" children={<IntuitErrorApp />} />
          <Route path="/unexpected-error" children={<GenericErrorPage />} />
          {/**
            Care App (/care) routes - replaced by server-side redirects
            @see https://github.com/SimplyInsured/site/pull/8829
            @see https://simplyinsured.atlassian.net/browse/SIM2-113
          */}

          <Route path={["/individual-application"]} children={<IndividualApplicationApp />} />
          <Route children={<FourOhFour />} />
        </Switch>
        <OptimizeActivate />
      </PageViewTracker>
    </Router>
  </Page>
);

export default App;
